module.exports = __webpack_public_path__ + "assets/google-slide-list.68aed166.svg";